<script>
export default {
  name: 'NotificationToggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isChecked() {
      return !!this.value
    },
  },
  methods: {
    toggle() {
      this.$emit('input', !this.isChecked)
    },
  },
}
</script>

<template>
  <button
    type="button"
    role="switch"
    :aria-checked="isChecked"
    @click="toggle"
    class="mc-notification-setting__toggle"
    :class="{ 'mc-notification-setting__toggle--active': isChecked }"
  >
    <span
      class="mc-notification-setting__toggle-thumb"
      :class="{ 'mc-notification-setting__toggle-thumb--active': isChecked }"
    />
  </button>
</template>
